import { Card, Container } from "@components/_Revamp/StyledComponent";
import { styled } from "@linaria/react";
import { css } from "@linaria/core";

import React, { useEffect, useReducer, useRef, useState } from "react";
import { themeDefault } from "src/theme-revamp";
import Button from "../../Components/Button";
import { Checkbox } from "@components/_Revamp/Checkbox";

import Input from "@components/_Revamp/Input";
import { get, isEmpty } from "lodash";
import { getAddressWithPostalCode } from "@api/index";
import { useHistory } from "react-router";
import { ROUTE_PATH } from "@static/route-paths";
import { useAvivaDispatch, useAvivaSelector } from "@redux/hook";
import { updateMailingAddressState } from "@redux/slices/SHIELD_STARTER/step3Slice";
import {
  QASPostalCodeRequest,
  QASPostalCodeResponse,
} from "@models/QASPostalCodeRequest";
import { Helpers, Validations } from "@utils/helpers";
import { calculateSpacer } from "@utils/spaceCalculation";
import { scrollToRef } from "@utils/scrollScript";
import { useLocation } from "react-router-dom";
import {Tooltip} from "@pages/ShieldStarter/Components/Tooltip";
import Stepper from "@pages/ShieldStarter/Components/Stepper";
import { STEPS_LIST } from "@static/content";
import MainContainer from "@pages/ShieldStarter/Components/Container";
import { SCREEN_SIZE } from "@static/screen-size";
import { trackOnLoad } from "@pages/ShieldStarter/Helpers/dataAnalyticsHelpers";
import {AA as AAShieldStarter } from "@utils/adobeAnalyticsSS";
import { setLoadingState } from "@redux/slices/loadingSlice";

const Header = styled.div<{maxWidth?:string}>`
  font-size: 28px;
  font-weight: 600;
  /* max-width: 588px; */
  /* width:${props=>props.maxWidth || "100%"}; */
  text-align: center;
  color: #434343;
  @media screen and (max-width:767px){
    font-size: 18px;
  }
  @media (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    white-space: break-spaces;
  }

`;

const Description = styled.div`
  margin-top: 16px;
  font-weight: 600;
  font-style: normal;
  font-size: 16px;
  color: #8A8988;
  text-align: center;
  @media screen and (max-width:767px){
    font-family: 'Open Sans';
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 140%;
    text-align: center;
  }
`;

const SpiltUpContainer = styled.div<{ mariginTop?: string }>`
  max-width: 100%;
  display: flex;
  margin-top: ${(props) => props.mariginTop || "60px"};
  & div {
    width: 100%;
    flex-grow: 1;
  }
  @media screen and (max-width: 767px){
    flex-direction:column;
    margin-top:0px;
    & div {
      display:flex;
      flex-direction:column;
      width: auto;
      flex-grow: 1;
      column-gap: 15px;
    }
  }
`;

const cardStyle = css`
  align-items: unset;
`;

const hideSytle= css`
  display:none;
  opacity: 0;
  transition: opacity 0.2s ease-in;
  margin-top: 120px;
`

const FieldLable = styled.div`
  font-size: 14px;
`;

const FieldValue = styled.div`
  font-style: normal;
  line-height: 140%;
  color: #434343;
  margin-top: 16px;
  font-weight: 600;
  font-size: 16px;
  @media screen and (max-width: 767px){
    margin-bottom:32px;
    font-size: 14px;
  }
`;

const CardDescription = styled.div`
  display: flex;
  font-size: 18px;
  font-weight: 600;
  color: #000;
  @media screen and (max-width:767px){
    margin-bottom:36px;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  justify-content: center;
  margin-top: 80px;
  @media screen and (max-width:767px){
    flex-direction:column;
    align-items:center;
  }
`;

const postalCodeStyle = css`
  display: flex;
  width: 100%;
  height: 66px;
  gap: 24px;
  label {
    font-size: 14px;
  }
  &:nth-child(1) {
    & input {
      margin-top: 10px;
    }
  }
  @media screen and (max-width:767px){
    height:auto;
  }
`;
const postalCodeInputStyle = css`
  display: flex;
  height: 66px;
  align-items: flex-start;
  gap: 24px;
  label {
    font-size: 14px;
  }
  & > div {
    & input {
      margin-top: 10px;
    }
    width: 100%;
    & input {
      max-width: 100%;
    }
  }

  @media screen and (max-width:767px){
    height:auto;
    & > div {
      margin-top:22px
    }
  }
`;

const UpdateMailingCheckboxContainer = styled.div`
  display: flex;
  flex-direction:row;
  margin-top: 36px;
  /* span:nth-child(2){
    padding-left:15px;
  } */
`;

const Disclaimer = styled.div`
  display: flex;
  font-size: 12px;
  font-weight: 500;
  margin-left: 5%;
  @media screen and (max-width: 767px){
    margin-left: 38px;
    margin-top: 5px;
  }
`;

const InvalidPostCodeMsg = styled.p`
  color: #c50000;
  margin-top: 10px;
  font-weight: 600;
  font-size: 12px;
`;

const LooksGoodStyle = styled.button<{ disabled: boolean }>`
  border: none;
  display: flex;
  flex-direction: row;
  justify-content: center;
  padding: 16px 60px;
  font-weight: 600;
  width: 282px;
  height: 52px;
  background: ${(prop) => (prop.disabled ? "#F5F5F5" : "#883E89")};
  border-radius: 101px;
  align-items: center;
  text-align: center;
  letter-spacing: 0.08em;
  transition: all 0.1s linear;
  color: ${(prop) => (prop.disabled ? "#C9C9C9" : "#FFF")};
  cursor: ${(prop) => (prop.disabled ? "auto" : "pointer")};
`;

enum InputState {
  UPDATE_BLOCK_NUMBER,
  UPDATE_UNIT_NUMBER,
  UPDATE_STREET_NAME,
  UPDATE_POST_CODE,
  UPDATE_BUILDING_NAME,
  UPDATE_ADDRESS,
  UPDATE_MAIL_ADDRESS_FOR_ALL,
  UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE
}

function MailingAddress() {
  const urlParams = Helpers.getURLSearchParams();

  // const [isUpdateMailingAddress, setUpdateMailingAddress] = useState(false);
  // const [postalCodeValue, setPostalCodeValue] = useState<number>();
  const [updateMailingCheckbox, setUpdateMailingCheckbox] = useState(false);
  const [invalidPostalCode, setInvalidPostalCode] = useState("");
  const [isDirty, setIsDirty] = useState(false);
  const [isLooksGoodEnabled, setIsLooksGoodEnabled] = useState(false);
  const residentialAddress = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalInfo.address
  );
  const mailingAddress = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalInfo?.mailingAddress
  );
  const customerId = useAvivaSelector(
    (state) => state.shieldStarterStep3.personalInfo?.customerId
  );
  const dispatch = useAvivaDispatch();
  const history = useHistory();
  const [isInvalidUnitNo, setIsInvalidUnitNo] = useState(false);
  const mailingAddressUpdateFormRef = useRef<null | HTMLDivElement>(null);
  const [searchButtonDisable, setSearchButtonDisable] = useState(false);
  const [addressData, dispatchAddressAction] = useReducer(reducer, {
    block: "",
    unitNo: "",
    street: "",
    postal: "",
    building: "",
    useMailAddressForAll: false,
  });
  const transactionId = useAvivaSelector(state=>state.shieldStarterStep3.transactionId)
  const SpacerRef = useRef<null | HTMLDivElement>(null);
  const [screenSize, setScreenSize] = useState(window.innerWidth);

  const detectScreenWidth = () => {
    setScreenSize(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", detectScreenWidth);
    return () => {
      window.removeEventListener("resize", detectScreenWidth);
    };
  }, [screenSize]);

  async function updateMailingAddress() {
    //update the mailing address in Store and goto next page
    dispatch(setLoadingState(true));
    try {
      const useMailAddressForAll = addressData?.useMailAddressForAll ? "Y" : "N";
      const addressPayload = {
        block: addressData.block,
        unitNo: addressData.unitNo,
        street: addressData.street,
        postalCode: addressData.postal,
        building: addressData.building,
        useMailAddressForAll,
        customerId
      }
      const payload = new QASPostalCodeRequest(addressPayload);
      await getAddressWithPostalCode(payload);
      dispatch(updateMailingAddressState(addressData));
      history.push(ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION);
      dispatch(setLoadingState(false));
    } catch (error) {
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
      dispatch(setLoadingState(false));
    }
    
  }

  function noChangeMailingAddress() {
    //TODO Set the next page once it's created
    dispatch(updateMailingAddressState(null));
    history.push(ROUTE_PATH.SHIELD_STARTER_HEALTH_DECLARATION);
  }

  function setMailingForAll() {
    dispatchAddressAction({
      type: InputState.UPDATE_MAIL_ADDRESS_FOR_ALL,
      useMailAddressForAll: !addressData.useMailAddressForAll,
    });
  }
function scrollToUpdateMail(){
    trackOnLoad("sss_mailing_address_update_form")

    setTimeout(() => {
      if (mailingAddressUpdateFormRef && mailingAddressUpdateFormRef.current) {
      mailingAddressUpdateFormRef.current.style.display= "block";
      let unit = -100
      screenSize < SCREEN_SIZE.mobilesUp &&  (unit = 20)
      screenSize > SCREEN_SIZE.mobilesUp && screenSize < SCREEN_SIZE.mobileSteper && (unit = -136)

        const elementOffSetTop = mailingAddressUpdateFormRef.current.offsetTop;
        calculateSpacer(mailingAddressUpdateFormRef, SpacerRef, false);
        const top = window.pageYOffset || document.documentElement.scrollTop;
        scrollToRef(
          document.documentElement,
          "scrollTop",
          unit,
          top,
          elementOffSetTop,
          300,
          true
        );
        mailingAddressUpdateFormRef.current.style.opacity = "1";
      }

    }, 100);


  }
  function reducer(state: any, payload: any) {
    switch (payload.type) {
      case InputState.UPDATE_ADDRESS: {
        if (!isDirty) {
          setIsDirty(true);
        }
        return { ...state, ...payload?.address };
      }
      case InputState.UPDATE_BLOCK_NUMBER: {
        return { ...state, block: payload?.block };
      }
      case InputState.UPDATE_UNIT_NUMBER: {
        return { ...state, unitNo: payload?.unitNo };
      }
      case InputState.UPDATE_STREET_NAME: {
        return { ...state, street: payload?.street };
      }
      case InputState.UPDATE_POST_CODE: {
        return { ...state, postal: payload?.postal };
      }
      case InputState.UPDATE_BUILDING_NAME: {
        return { ...state, building: payload?.building };
      }
      case InputState.UPDATE_MAIL_ADDRESS_FOR_ALL: {
        return { ...state, useMailAddressForAll: payload.useMailAddressForAll };
      }
      case InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE:{
        return {...state, ...payload.mailingaddress}
      }
      default:
        return state;
    }
  }

  const trackOnStart = (formName: string) =>{
      const AA = AAShieldStarter.getInstance();
      let { form } = AA.digitalData;
      form.name = formName;
      AA.trackPageStart({form});
    }
  

  function validatePostCode() {
    if (addressData.postal.toString().length < 6) {
      setInvalidPostalCode("Please enter a valid postal code");
    }
  }

  function setPostalCodeValue(value: string) {
    if (value.length <= 6) {
      if (invalidPostalCode) {
        setInvalidPostalCode("");
      }
      //TODO: Check with business if changing the postal code needs to erase all the fields
      // dispatchAddressAction({
      //   type: InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE,
      //   mailingaddress: {
      //     block: "",
      //     unitNo: "",
      //     street: "",
      //     postal: "",
      //     building: ""
      //   },
      // });
      dispatchAddressAction({
        type: InputState.UPDATE_POST_CODE,
        postal: value,
      });
    }
  }

  async function fetchAddressWithPostalCode() {
    setSearchButtonDisable(true)
    // trackOnStart("search_postal_code")
    let zipcode = addressData.postal;
    const payload = new QASPostalCodeRequest({ postalCode: zipcode });
    try {
      const response = await getAddressWithPostalCode(payload);
      const data = get(response, "data");
      if(!data.valid){
        setSearchButtonDisable(false)
        setInvalidPostalCode("We couldn't find your postal code. Enter your address below.");
        return
      }
      const address = new QASPostalCodeResponse(data);
      const unit = get(address, "addressLine3", undefined);
      let addressRestructured = {
        block: get(address, "addressLine1", ""),
        unitNo: isEmpty(unit) ? undefined : unit,
        street: get(address, "addressLine2", ""),
        building: get(address, "addressLine4", ""),
        postal: zipcode,
      };

      setSearchButtonDisable(false)
      dispatchAddressAction({ type: InputState.UPDATE_ADDRESS, address: addressRestructured });
    } catch (error) {
      setSearchButtonDisable(false);
      history.push(ROUTE_PATH.SHIELD_STARTER_GENERIC_ERROR);
    }

  }

  useEffect(() => {
    if (
      addressData.postal?.length === 6 &&
      addressData.unitNo &&
      addressData.street
    ) {
      setIsLooksGoodEnabled(true);
    } else {
      setIsLooksGoodEnabled(false);
    }
  }, [addressData]);

  useEffect(() => {
    function goBack() {
      //TODO : update the update the right one for go back
      if (
        !residentialAddress ||
        !residentialAddress.block ||
        !residentialAddress.postal
      ) {
        history.replace(ROUTE_PATH.SHIELD_STARTER_SINGPASS_PERSMISSION);
      } else {
        trackOnLoad("sss_mailing_address_confirmation");
      }
    }
    goBack();
  }, []);

  useEffect(() => {
    const review = urlParams.get("review");
    if (mailingAddress ) {
      scrollToUpdateMail();
      dispatchAddressAction({type:InputState.UPDATE_ENTIRE_MAILADDRESS_FROM_REDUX_STORE ,mailingaddress: mailingAddress})
    }
  }, []);

  return (
    <>
      <MainContainer step={3} backButtonPath={`${ROUTE_PATH.SHIELD_STARTER_MY_INFO}?transaction_id=${transactionId}`}>
        <Header>
          {"Is your mailing address the same as your  \nresidential address?"}
        </Header>

        <Description>
          Your details were filled automatically from Myinfo.
        </Description>
        <Card className={cardStyle} opacityValue="unset">
          <>
            <CardDescription>Residential Address</CardDescription>
            <SpiltUpContainer mariginTop="36px">
              <div>
                <FieldLable>Block</FieldLable>
                <FieldValue>{residentialAddress?.block || "-"}</FieldValue>
              </div>
              <div>
                <FieldLable>Unit Number (If any)</FieldLable>
                <FieldValue>{residentialAddress?.unitNo || "-"}</FieldValue>
              </div>
            </SpiltUpContainer>
            <SpiltUpContainer mariginTop="44px">
              <div>
                <FieldLable>Street Name</FieldLable>
                <FieldValue>{residentialAddress?.street || "-"}</FieldValue>
              </div>
              <div>
                <FieldLable>Postal Code</FieldLable>
                <FieldValue>{residentialAddress?.postal || "-"}</FieldValue>
              </div>
            </SpiltUpContainer>
            <SpiltUpContainer mariginTop="44px">
              <div>
                <FieldLable>Building Name (If any)</FieldLable>
                <FieldValue>{residentialAddress?.building || "-"}</FieldValue>
              </div>
            </SpiltUpContainer>
          </>
        </Card>
        <ButtonContainer>
            <>
              <Button
                boxShadowDisabled={true}
                label="No"
                onClick={scrollToUpdateMail}
                width="180px"
                bgColor="white"
                hoverBgColor="white"
                hoverTextColor={themeDefault.colors.primary}
                textColor={themeDefault.colors.primary}
              />
              <Button
                onClick={noChangeMailingAddress}
                label="Yes"
                width="180px"
              />
            </>
          </ButtonContainer>

        <div className={hideSytle} ref={mailingAddressUpdateFormRef}>
          <Header maxWidth="100%">Update your mailing address</Header>
          <Description>We can only accept Singapore address.</Description>
          <Card className={cardStyle} marginTop={"64px"}>
            <>
              <SpiltUpContainer mariginTop="0">
                <div className={postalCodeStyle}>
                  <div>
                    <label>Postal Code</label>
                    <>
                      <Input
                        margin={0}
                        type="number"
                        maxLength={6}
                        value={addressData.postal}
                        onChange={(e) => setPostalCodeValue(e.target.value)}
                        boxLabel="Postal Code"
                        invalid={!!invalidPostalCode}
                        onBlur={validatePostCode}
                        inputMode="numeric"
                      />
                      {invalidPostalCode && (
                        <InvalidPostCodeMsg>
                          {invalidPostalCode}
                        </InvalidPostCodeMsg>
                      )}
                    </>
                  </div>
                  <div>
                    <Button
                      disabled={
                        searchButtonDisable || !addressData.postal || addressData.postal.length < 6
                      }
                      onClick={() => fetchAddressWithPostalCode()}
                      label="Search"
                      margin={"7px 0px 7px 0px"}
                      bgColor="white"
                      textColor={themeDefault.colors.primary}
                      width="210px"
                      height="52px"
                      padding={"16px 24px"}
                    />
                  </div>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer>
                <div className={postalCodeInputStyle}>
                  <div>
                    <label>Block</label>
                    <Input
                      margin={0}
                      value={addressData.block}
                      type="alphanumeric"
                      maxLength={30}
                      onChange={(e) => {
                        dispatchAddressAction({
                          type: InputState.UPDATE_BLOCK_NUMBER,
                          block: e.target.value,
                        });
                      }}
                      boxLabel="Block"
                    />
                  </div>
                  <div>
                    <label>Street Name</label>
                    <Input
                      value={addressData.street}
                      type="alphanumeric"
                      maxLength={60}
                      onChange={(e) => {
                        dispatchAddressAction({
                          type: InputState.UPDATE_STREET_NAME,
                          street: e.target.value,
                        });
                      }}
                      margin={0}
                      boxLabel="Street Name"
                    />
                  </div>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer>
                <div className={postalCodeInputStyle}>
                  <div>
                    <label style={{display: "flex", alignItems: "center", gap: "10px"}}>
                      <span>Unit Number</span>
                      <Tooltip title="Unit Number" isIcon={true}>
                        <ul>
                          <li>
                            For unit number, please input # followed by
                            numeral digits (e.g. #12-456)
                          </li>
                          <li>
                            For P.O. Box, please input numeral digits zero
                            (eg. 0)
                          </li>
                          <li>
                            For landed property, please input numeral digits
                            (eg. 00-00)
                          </li>
                        </ul>
                      </Tooltip>
                    
                    </label>
                    <Input
                      onChange={(e) => {
                        const value = e.target.value
                        if((/(\d|#|-)/.test(value.slice(-1))|| value==="")&& value.length<=10){
                        dispatchAddressAction({
                          type: InputState.UPDATE_UNIT_NUMBER,
                          unitNo: value,
                        });
                        const pattern = /^(#\d{1,3}-\d{1,5})$|(([0]{1}))$|^([0-9]{1,6})-([0-9]{1,6})$/;
                        if (!Validations.isValidUinit(value,pattern)) {
                          setIsInvalidUnitNo(true);
                        } else if (isInvalidUnitNo) {
                          setIsInvalidUnitNo(false);
                        }}
                      }}
                      invalid={isInvalidUnitNo}
                      value={addressData.unitNo}
                      margin={0}
                      boxLabel="Unit Number"
                    />
                    {isInvalidUnitNo && (
                      <InvalidPostCodeMsg>
                        Please enter a valid unit
                      </InvalidPostCodeMsg>
                    )}
                  </div>
                  <div>
                    <label>Building Name</label>
                    <Input
                      type="alphanumeric"
                      maxLength={30}
                      onChange={(e) => {
                        dispatchAddressAction({
                          type: InputState.UPDATE_BUILDING_NAME,
                          building: e.target.value,
                        });
                      }}
                      value={addressData.building}
                      margin={0}
                      boxLabel="Building Name"
                    />
                  </div>
                </div>
              </SpiltUpContainer>
              <SpiltUpContainer mariginTop="0" style={{fontSize: "12px", fontWeight: 500}}>
                <UpdateMailingCheckboxContainer style={{display:"flex", flexDirection:"row"}} >
                  <span>
                    <Checkbox
                      checked={addressData.useMailAddressForAll}
                      onChange={setMailingForAll}
                    />
                  </span>
                 <span> I would like to also update this mailing address for all my
                  life and health policy(ies) with Singlife.*</span>
                </UpdateMailingCheckboxContainer>
              </SpiltUpContainer>
              <Disclaimer>
                *Not applicable to MINDEF & MHA Group Insurance / POGIS
              </Disclaimer>
            </>
          </Card>

          <ButtonContainer>
            <LooksGoodStyle
              disabled={!isLooksGoodEnabled || isInvalidUnitNo}
              onClick={updateMailingAddress}
            >
              Save
            </LooksGoodStyle>
          </ButtonContainer>
        </div>
      </MainContainer>
      <div ref={SpacerRef}></div>      
    </>
  );
}

export default MailingAddress;
